import {
  DataObjectGroupType,
  FilterInputProps,
  FocusRef,
  useGroupOrDescriptionOptions,
} from '@atlas-frontend/sdk';
import { forwardRef, useMemo } from 'react';
import translations from './OutputGroupDescriptionFilterInput.translations.json';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import { GroupDescriptionFilterInput } from '../input-data/GroupDescriptionFilterInput';

const { addTranslations, useTranslation } = i18nNsFactory(
  'output-group-description-filter-input',
);
addTranslations(translations);

export const OutputGroupDescriptionFilterInput = forwardRef<
  FocusRef,
  FilterInputProps
>((props, ref) => {
  const { t } = useTranslation();

  const [descriptionGroupOptions, ungroupedDescriptionOptions] =
    useGroupOrDescriptionOptions(DataObjectGroupType.O);

  const options = useMemo(
    () => [
      {
        key: 'description-groups',
        label: t('option-group.description-groups'),
        options: descriptionGroupOptions,
      },
      {
        key: 'ungrouped-descriptions',
        label: t('option-group.ungrouped-descriptions'),
        options: ungroupedDescriptionOptions,
      },
    ],
    [t, descriptionGroupOptions, ungroupedDescriptionOptions],
  );

  return (
    <GroupDescriptionFilterInput
      {...props}
      options={options}
      ref={ref}
      placeholder={t('placeholder')}
    />
  );
});
